import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { cmsApiConfig } from '../../cmsConfig';
import { ContentPage } from '../../types/ContentPageSection';

export interface PreviewContentPageArgs {
  id: number;
  token: string;
}

export const previewApi = createApi({
  reducerPath: 'previewApi',
  baseQuery: fetchBaseQuery({ baseUrl: cmsApiConfig.url }),
  endpoints: (builder) => ({
    getPreviewContentPage: builder.query<ContentPage, PreviewContentPageArgs>({
      query: ({ id, token }) => ({
        url: `/preview/content/${id}`,
        params: { token },
      }),
    }),
  }),
});

export const { useGetPreviewContentPageQuery } = previewApi;
